var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathtub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7558 21.1948V23.7526",
    stroke: "#6D737A",
    strokeWidth: 1.82577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6923 21.1948V23.7526",
    stroke: "#6D737A",
    strokeWidth: 1.82577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04889 11.8165V6.27457C6.04889 5.70926 6.27346 5.1671 6.67319 4.76737C7.07293 4.36763 7.61508 4.14307 8.18039 4.14307C8.7457 4.14307 9.28786 4.36763 9.68759 4.76737C10.0873 5.1671 10.3119 5.70926 10.3119 6.27457",
    stroke: "#6D737A",
    strokeWidth: 1.82577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3971 10.9639H14.5763V16.0795H21.3971V10.9639Z",
    stroke: "#6D737A",
    strokeWidth: 1.82577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3962 11.8164H24.8066C25.0327 11.8164 25.2496 11.9062 25.4095 12.0661C25.5694 12.226 25.6592 12.4429 25.6592 12.669V16.0794C25.6592 17.4362 25.1203 18.7373 24.1609 19.6967C23.2015 20.6561 21.9004 21.195 20.5436 21.195H6.90199C5.54524 21.195 4.24407 20.6561 3.2847 19.6967C2.32534 18.7373 1.78638 17.4362 1.78638 16.0794V12.669C1.78638 12.4429 1.8762 12.226 2.0361 12.0661C2.19599 11.9062 2.41285 11.8164 2.63898 11.8164H14.5754",
    stroke: "#6D737A",
    strokeWidth: 1.82577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtub);
export default __webpack_public_path__ + "static/media/Bathtub.5936b123dbe77fad72c15c285670ccc7.svg";
export { ForwardRef as ReactComponent };